









import {Component, Prop, Vue} from "vue-property-decorator";
import {MainPageConfig} from "@/interfaces/main-page.interface";

@Component({
  components: {

  }
})

export default class TextBox extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;

  // @todo remove it
  @Prop() item: any;

  @Prop() title: string;
  @Prop() text: string;

  mounted() {
    document.querySelectorAll('.text-box__text').forEach(text => {
      text.querySelectorAll('a').forEach(link => {
        link.setAttribute('target', '_blank');
      });
    });
  }
}
